import {AdDataModel} from '../models/AdDataModel';
import {AdMessageConfigModel} from '../models/AdMessageConfigModel';
import {Subscription, timer} from 'rxjs';

const MESSAGE_CONFIG: AdMessageConfigModel = {
  TEXT: {
    x: 55,
    y: 31,
    font: '16px Arial'
  },
  IMAGE: {
    x: 10,
    y: 11,
    width: 30,
    height: 30
  }
};

export class AdMessage {
  private canvas: HTMLCanvasElement;
  private counter = 0;
  private textWidth = 0;
  readonly ctx: CanvasRenderingContext2D;
  previewData: AdDataModel;
  loadedImage: HTMLImageElement;
  renderProcessing: boolean;

  constructor(canvas: HTMLCanvasElement, previewData: AdDataModel) {
    this.canvas = canvas;
    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;
    this.previewData = previewData;
    this.ctx = this.canvas.getContext('2d');
    this.fadeInCanvas();
  }

  fadeInCanvas() {
    const pauseTimer: Subscription = timer(500).subscribe( () => {
      this.canvas.style.opacity = '1';
      this.initRender();
      pauseTimer.unsubscribe();
    });
  }

  initRender() {
    this.renderProcessing = true;
    if ( this.previewData.image ) {
      MESSAGE_CONFIG.TEXT.x = 55;
      this.loadedImage = new Image();
      this.loadedImage.onload = () => this.render();
      this.loadedImage.src = this.previewData.image;
    } else {
      MESSAGE_CONFIG.TEXT.x = 10;
      this.render();
    }
  }

  setCanvasBg() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fillStyle = this.previewData.bgColor;
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
  }

  addText() {
    const textWidth: TextMetrics = this.ctx.measureText(this.previewData.message);
    this.textWidth = textWidth.width;

    const {x, y, font} = MESSAGE_CONFIG.TEXT;
    const imageWidth = MESSAGE_CONFIG.IMAGE.width;
    this.ctx.font = font;
    this.ctx.fillStyle = this.previewData.textColor;
    this.ctx.fillText(this.previewData.message, x - this.counter, y);
    if ( !this.previewData.logoHold ) {
      this.ctx.fillText(this.previewData.message, x + textWidth.width + this.canvas.width + imageWidth - this.counter, y);
    } else {
      this.ctx.fillText(this.previewData.message, x + textWidth.width + this.canvas.width - this.counter, y);
    }

    if ( this.previewData.logoHold && x + textWidth.width + this.canvas.width - this.counter <= x ) {
      return this.stopRender();
    } else if ( !this.previewData.logoHold && x + textWidth.width + this.canvas.width + imageWidth - this.counter <= x ) {
      return this.stopRender();
    }
  }

  addImage() {
    if ( !this.previewData.image ) return;

    const {x, y, width, height} = MESSAGE_CONFIG.IMAGE;

    this.ctx.fillStyle = this.previewData.bgColor;

    if ( this.previewData.logoHold ) {
      this.ctx.fillRect(0, 0, width + 10, this.canvas.height);
      this.ctx.drawImage(this.loadedImage, x, y, width, height);
    } else {
      this.ctx.drawImage(this.loadedImage, x - this.counter, y, width, height);
      this.ctx.drawImage(this.loadedImage, x + this.textWidth + this.canvas.width + width - this.counter, y, width, height);
    }
  }

  render() {
    this.setCanvasBg();
    this.addText();
    this.addImage();
    if ( this.renderProcessing ) {
      if ( this.counter === 0 ) {
        const pauseTimer: Subscription = timer(500).subscribe( () => {
          this.counter += 0.5;
          requestAnimationFrame(() => this.render());
          pauseTimer.unsubscribe();
        });
      } else {
        this.counter += 0.5;
        requestAnimationFrame(() => this.render());
      }
    }
  }

  private stopRender() {
    this.renderProcessing = false;
    const pauseTimer: Subscription = timer(1000).subscribe( () => {
      this.canvas.style.opacity = '0';
      pauseTimer.unsubscribe();
      this.showAddMessage();
    });
  }

  private showAddMessage() {
    const pauseTimer: Subscription = timer(1000).subscribe( () => {
      this.counter = 0;
      this.fadeInCanvas();
      pauseTimer.unsubscribe();
    });
  }
}
